var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isConnected)?_c('div',{staticClass:"app-connection-status"},[_c('span',[_vm._v("Нет подключения к серверу")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }